import { BUILDINGS, TREE_GROW_TICKS } from '../../shared/constants'
import type { Building } from '../../shared/types'

/** Simulation time drives growth, so reconnecting never restarts a sapling. */
export function treeGrowthFraction(b: Building, tick: number): number {
  if (!b.done || b.treeGrowsAt === undefined) return 0
  return Math.max(0, Math.min(1, 1 - (b.treeGrowsAt - tick) / TREE_GROW_TICKS))
}

/** Three visibly different ages; the terrain owns the mature tree at day three. */
export function treeGrowthStage(b: Building, tick: number): number {
  return Math.min(2, Math.floor(treeGrowthFraction(b, tick) * 3))
}

/** A sprout, with an amber planting ring or green living-growth progress. */
export function drawTreeGrowthBadge(
  ctx: CanvasRenderingContext2D, b: Building, tick: number, x: number, y: number, size = 11,
): void {
  const progress = b.done ? treeGrowthFraction(b, tick)
    : Math.max(0, Math.min(1, b.progress / Math.max(1, BUILDINGS.plant.buildTime)))
  ctx.save()
  ctx.fillStyle = 'rgba(12,23,14,0.88)'
  ctx.beginPath(); ctx.arc(x, y, size, 0, Math.PI * 2); ctx.fill()
  ctx.lineWidth = Math.max(1.5, size * 0.15)
  ctx.strokeStyle = b.done ? '#486b45' : '#e7b25b'
  ctx.stroke()
  if (progress > 0) {
    ctx.strokeStyle = b.done ? '#b7e77d' : '#ffe0a0'
    ctx.beginPath(); ctx.arc(x, y, size, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * progress); ctx.stroke()
  }
  ctx.strokeStyle = '#c0e49a'
  ctx.lineCap = 'round'
  ctx.lineWidth = size * 0.15
  ctx.beginPath(); ctx.moveTo(x, y + size * 0.5); ctx.quadraticCurveTo(x - size * 0.06, y, x + size * 0.13, y - size * 0.39); ctx.stroke()
  ctx.fillStyle = '#7fc868'
  ctx.beginPath(); ctx.ellipse(x - size * 0.24, y - size * 0.06, size * 0.3, size * 0.16, 0.6, 0, Math.PI * 2); ctx.fill()
  ctx.fillStyle = '#c1e78b'
  ctx.beginPath(); ctx.ellipse(x + size * 0.28, y - size * 0.32, size * 0.3, size * 0.17, -0.55, 0, Math.PI * 2); ctx.fill()
  ctx.restore()
}
